import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  profileInformationContainer: {
    padding: theme.spacing(5),
    border: `1px solid #DBDBDB`,
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  profileInformationColumnContainer: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      flex: 1,
    },
  },
  profileInformationRow: {
    padding: `${theme.spacing(1.5)} 0`,
    borderBottom: `1px solid #666666`,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    maxHeight: "50px",
    height: "50px",
  },
  testsProgressContainer: {
    padding: theme.spacing(5),
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(1),
    border: `1px solid #DBDBDB`,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  recruitmentProcessContainer: {
    padding: theme.spacing(5),
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(1),
    border: `1px solid #DBDBDB`,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

export default useStyles;
